module.exports = __webpack_public_path__ + "static/media/industries-fodder-s.b53fa12b.webp";